import theme from '@styles/theme';
export default {
  container: {
    width: '100%',
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    height: 'auto',
    display: 'flex',
    flexFlow: 'row wrap',
    alignContent: 'space-between',
    justifyContent: 'space-between',
    backgroundColor: theme.rawColors.beige500,
    rowGap: ['16px', '24px', '24px', 0, 0],
    p: ['64px 16px', '64px 16px', '64px 16px', '80px 40px']
  },
  item: {
    flex: '1 0 18%',
    widtht: 'auto',
    minWidth: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
    alignItems: 'center',
    justifyContent: 'center',
    '.icon': {
      mb: '16px'
    },
    p: {
      font: theme.fonts.uniformMedium,
      fontSize: theme.fontSizes.text,
      textAlign: 'center'
    }
  }
};